export const ENT_PAGE_TITLE = {
    DASHBOARD : "Dashboard",
    INVITES_PENDING : "Invites Pending",
    INACTIVE_USERS : "Inactive Users",
    MANAGE_USERS : "Manage Team",
    TEAM_FOLDERS : "Team Folders",
    REPORTS : "Reports",
    SETTINGS : "Settings"
}